export const CHARGE_ONLY_COST_MESSAGE = 'Only a charge line carries a cost.';
//# sourceMappingURL=charge-only-cost-message.js.map